import React, { useState, useEffect } from "react";
import { FaSave, FaTimes } from "react-icons/fa";
import { createAdherentPret } from "../../../services/adherentpretServices";
import { getAllAdherentsList } from "../../../services/adherentServices";
import { getArticles } from "../../../services/articlesServices";
import Button from "../../../components/Button/Button";
import { toast } from "react-toastify";

const AddAdherentPretModal = ({ isOpen, onClose, refreshList }) => {
  const [formData, setFormData] = useState({
    adherent_id: "",
    article_id: "",
    date_pret: "",
    note_pret: "",
  });

  const [adherents, setAdherents] = useState([]);
  const [articles, setArticles] = useState([]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const adherentsData = await getAllAdherentsList();
        const articlesData = await getArticles();
        setAdherents(adherentsData);
setArticles(articlesData.filter((a) => a.categorie === "Prêt"));
      } catch (error) {
        toast.error("Erreur chargement adhérents ou articles");
      }
    };

    if (isOpen) {
      fetchData();
    }
  }, [isOpen]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      await createAdherentPret(formData);
      toast.success("Prêt enregistré avec succès");
      refreshList();
      onClose();
    } catch (error) {
      console.error("Erreur lors de la création du prêt", error);
      toast.error("Erreur lors de la création du prêt");
    }
  };

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50">
      <div className="modal-box bg-white p-4 rounded-lg shadow-lg w-full max-w-lg">
        <h3 className="text-xl font-bold uppercase p-3 mb-4 text-center text-white bg-primary rounded-md shadow">
          Nouveau Prêt de Matériel
        </h3>
        <form onSubmit={handleSubmit}>
          <select
            name="adherent_id"
            value={formData.adherent_id}
            onChange={handleChange}
            className="input input-bordered w-full mb-3"
            required
          >
            <option value="">-- Sélectionner un adhérent --</option>
            {adherents.map((a) => (
              <option key={a.id} value={a.id}>
                {a.prenom} {a.nom}
              </option>
            ))}
          </select>

          <select
            name="article_id"
            value={formData.article_id}
            onChange={handleChange}
            className="input input-bordered w-full mb-3"
            required
          >
            <option value="">-- Sélectionner un matériel --</option>
            {articles.map((a) => (
              <option key={a.id} value={a.id}>
                {a.nom} ({a.categorie})
              </option>
            ))}
          </select>

          <input
            type="date"
            name="date_pret"
            value={formData.date_pret}
            onChange={handleChange}
            className="input input-bordered w-full mb-3"
            required
          />

          <input
            type="text"
            name="note_pret"
            placeholder="Note éventuelle"
            value={formData.note_pret}
            onChange={handleChange}
            className="input input-bordered w-full mb-3"
          />

          <div className="flex justify-center space-x-2 mt-4">
            <Button text="Enregistrer" icon={FaSave} type="submit" className="btn-primary gap-2" />
            <Button text="Annuler" icon={FaTimes} onClick={onClose} type="button" className="btn-ghost gap-2" />
          </div>
        </form>
      </div>
    </div>
  );
};

export default AddAdherentPretModal;
